module.exports = __webpack_public_path__ + "img/7742f0223050acd4abdd36b46a9dc584.222ffdc3.png";